import React from 'react';
import Hero from '../components/Hero';
import ChairmanMessage from '../components/ChairmanMessage';
import WhyInvest from '../components/WhyInvest';

const Home = () => {
  return (
    <>
      <Hero />
      <ChairmanMessage />
      <WhyInvest />
    </>
  );
};

export default Home;
